export const css = {
    root: '_1BUJVTob',
    grouphead: '_2E0o1Q5G',
    actions: '_19_Sx3IW',
    group: '_1LVgrO4L',
    progress: '_3kfP_-8O',
    toc: '_3WVEwPQU',
    resource: '_2TIxV5jn',
    competencyConnection: 'nSx35mVO',
    topicBlock: '_2UM5oDYt',
    titleBlock: 'q_z9yPfw',
    title: '_2f6BxFxu',
    close: '_3X7XxwqU',
    deck: '_1TDpPwrc',
    refTitleBlock: '_3qJdgGZg',
    complete: '_39xUF26y',
    incomplete: 'HAD0mY67',
    refTitle: '_2_oPEZZf',
    fragment: '_3BW4knoP',
    readButton: '_1FQKuaDC',
    legend: '_3MhR7UZi',
    legendText: '_2_v1PXUe',
    action: 'NlDdgX1D',
    actionIcon: '_2yFi_Qio',
    actionText: '_199FV4Ch',
    activitycontent: 'lFSLL2pv',
    videolink: '_3YAggQKP',
    cialink: '_293ky1DT',
    ciacontent: '_2Z58xQvs',
    resourcecontent: '_2rPEzlMc',
    resourcelink: '_1O0lddu5',
    scorePill: '_2WKxRHaC',
    topicAudio: '_15zFx-WD',
    ' _key': 'apic-theme/apic/book-widgets/topicgroup'
};
export default css;
